<template>
  <section class="product-slider-section py-16 bg-gray-50">
    <div class="container mx-auto px-4">
      <div class="flex justify-between items-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold">热门产品</h2>
        <div class="flex space-x-2">
          <button 
            class="product-nav-btn w-10 h-10 rounded-full bg-white shadow flex items-center justify-center text-gray-600 hover:text-blue-600 transition-colors"
            @click="prevSlide"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <button 
            class="product-nav-btn w-10 h-10 rounded-full bg-white shadow flex items-center justify-center text-gray-600 hover:text-blue-600 transition-colors"
            @click="nextSlide"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      
      <div class="relative overflow-hidden">
        <div 
          ref="carouselContainer"
          class="carousel-container flex overflow-x-auto snap-x snap-mandatory scrollbar-hide"
        >
          <!-- 第一组产品 -->
          <div class="carousel-item flex-shrink-0 w-full snap-center px-4">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
              <!-- 产品1 -->
              <div class="product-card shadow-lg overflow-hidden scroll-animate bg-white rounded-xl transition-all duration-300 hover:translate-y-[-10px]">
                <img src="https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="5G无线路由终端" class="w-full h-64 object-cover">
                <div class="p-6">
                  <h3 class="text-xl font-bold mb-2">5G无线路由终端</h3>
                  <p class="text-gray-600 mb-4">chmura云通讯推出的高性能5G无线路由终端，支持SA/NSA双模5G网络，提供高达1.2Gbps的下载速度和100Mbps的上传速度。采用智能天线技术，覆盖范围扩大30%，适用于家庭、小型企业和移动办公场景，为用户提供高速稳定的无线网络连接体验。</p>
                  <a href="#" class="text-blue-600 font-medium hover:text-blue-800 transition-colors">查看详情</a>
                </div>
              </div>
              
              <!-- 产品2 -->
              <div class="product-card shadow-lg overflow-hidden scroll-animate bg-white rounded-xl transition-all duration-300 hover:translate-y-[-10px]">
                <img src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="5G基站设备" class="w-full h-64 object-cover">
                <div class="p-6">
                  <h3 class="text-xl font-bold mb-2">5G基站设备</h3>
                  <p class="text-gray-600 mb-4">chmura云通讯5G基站设备采用先进的Massive MIMO和波束赋形技术，支持2.6GHz和3.5GHz频段，单基站容量提升10倍。具备智能温控和节能设计，能耗降低40%，同时支持边缘计算功能，为工业互联网、自动驾驶等低时延应用提供网络保障。</p>
                  <a href="#" class="text-blue-600 font-medium hover:text-blue-800 transition-colors">查看详情</a>
                </div>
              </div>
              
              <!-- 产品3 -->
              <div class="product-card shadow-lg overflow-hidden scroll-animate bg-white rounded-xl transition-all duration-300 hover:translate-y-[-10px]">
                <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="企业路由器" class="w-full h-64 object-cover">
                <div class="p-6">
                  <h3 class="text-xl font-bold mb-2">企业路由器</h3>
                  <p class="text-gray-600 mb-4">chmura云通讯企业路由器采用高性能处理器和专业级网络芯片，支持千兆级有线和无线传输。具备防火墙、VPN、负载均衡等企业级功能，支持500+用户同时在线。提供WEB界面和CLI管理方式，配置简单，运维便捷，是中小企业网络的理想选择。</p>
                  <a href="#" class="text-blue-600 font-medium hover:text-blue-800 transition-colors">查看详情</a>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 第二组产品 -->
          <div class="carousel-item flex-shrink-0 w-full snap-center px-4">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
              <!-- 产品4 -->
              <div class="product-card shadow-lg overflow-hidden scroll-animate bg-white rounded-xl transition-all duration-300 hover:translate-y-[-10px]">
                <img src="https://images.unsplash.com/photo-1518779578993-ec3579fee39f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="物联网卡" class="w-full h-64 object-cover">
                <div class="p-6">
                  <h3 class="text-xl font-bold mb-2">物联网卡</h3>
                  <p class="text-gray-600 mb-4">chmura云通讯物联网卡支持2G/3G/4G/5G多种网络制式，提供全球覆盖服务。采用工业级设计，工作温度范围-40℃至85℃，具备稳定可靠的连接性能。支持远程管理和流量监控，适用于智能穿戴、智能水表、工业设备等各类物联网场景，满足百万级设备连接需求。</p>
                  <a href="#" class="text-blue-600 font-medium hover:text-blue-800 transition-colors">查看详情</a>
                </div>
              </div>
              
              <!-- 产品5 -->
              <div class="product-card shadow-lg overflow-hidden scroll-animate bg-white rounded-xl transition-all duration-300 hover:translate-y-[-10px]">
                <img src="https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="全屋智能网关" class="w-full h-64 object-cover">
                <div class="p-6">
                  <h3 class="text-xl font-bold mb-2">全屋智能网关</h3>
                  <p class="text-gray-600 mb-4">chmura云通讯全屋智能网关作为智能家居控制中心，支持Wi-Fi 6、Zigbee、蓝牙5.0等多种协议，可连接200+智能设备。提供语音控制、场景联动和远程管理功能，支持AI学习用户习惯，自动优化设备运行状态。采用安全加密技术，保障家庭网络和数据安全。</p>
                  <a href="#" class="text-blue-600 font-medium hover:text-blue-800 transition-colors">查看详情</a>
                </div>
              </div>
              
              <!-- 产品6 -->
              <div class="product-card shadow-lg overflow-hidden scroll-animate bg-white rounded-xl transition-all duration-300 hover:translate-y-[-10px]">
                <img src="https://images.unsplash.com/photo-1583394838336-acd977736f90?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="视频监控系统" class="w-full h-64 object-cover">
                <div class="p-6">
                  <h3 class="text-xl font-bold mb-2">视频监控系统</h3>
                  <p class="text-gray-600 mb-4">chmura云通讯视频监控系统采用4K高清摄像头，支持AI智能分析功能，可识别人体、车辆、物体等。提供云端存储和远程查看服务，支持多设备联动和智能告警。采用H.265编码技术，存储容量节省50%，适用于家庭、商铺、企业等安防场景，提供全面的安全保障。</p>
                  <a href="#" class="text-blue-600 font-medium hover:text-blue-800 transition-colors">查看详情</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductSlider',
  methods: {
    prevSlide() {
      const container = this.$refs.carouselContainer;
      const itemWidth = container.querySelector('.carousel-item').offsetWidth;
      container.scrollBy({ left: -itemWidth, behavior: 'smooth' });
    },
    nextSlide() {
      const container = this.$refs.carouselContainer;
      const itemWidth = container.querySelector('.carousel-item').offsetWidth;
      container.scrollBy({ left: itemWidth, behavior: 'smooth' });
    }
  }
}
</script>

<style scoped>
.product-slider-section {
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
}

.product-nav-btn {
  transition: all 0.3s ease;
}

.product-nav-btn:hover {
  transform: scale(1.1);
}

.carousel-container {
  width: 100%;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.carousel-container::-webkit-scrollbar {
  display: none;
}

.carousel-item {
  width: 100%;
  flex-shrink: 0;
}

.product-card {
  border-radius: 12px;
  border: none;
  border-top: 4px solid #3b82f6;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}
</style>